import React, { useState } from 'react';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import topok1 from "../img/top/topok1.png"
import topok2 from "../img/top/topok2.png"
import topok3 from "../img/top/topok3.png"
import topok4 from "../img/top/topok4.png"
import topnotok1 from "../img/top/topnotok1.png"
import topnotok2 from "../img/top/topnotok2.png"
import topnotok3 from "../img/top/topnotok3.png"
import topnotok4 from "../img/top/topnotok4.png"
import topnotok5 from "../img/top/topnotok5.png"
import topnotok6 from "../img/top/topnotok6.png"
import topnotok7 from "../img/top/topnotok7.png"
import topnotok8 from "../img/top/topnotok8.png"
import topnotok9 from "../img/top/topnotok9.png"
import topnotok10 from "../img/top/topnotok10.png"
import bottomok1 from "../img/bottom/bottomok1.png"
import bottomok2 from "../img/bottom/bottomok2.png"
import bottomok3 from "../img/bottom/bottomok3.png"
import bottomok4 from "../img/bottom/bottomok4.png"
import bottomok5 from "../img/bottom/bottomok5.png"
import bottomok6 from "../img/bottom/bottomok6.png"
import bottomnotok1 from "../img/bottom/bottomnotok1.png"
import bottomnotok2 from "../img/bottom/bottomnotok2.png"
import bottomnotok3 from "../img/bottom/bottomnotok3.png"
import bottomnotok4 from "../img/bottom/bottomnotok4.png"
import bottomnotok5 from "../img/bottom/bottomnotok5.png"
import bottomnotok6 from "../img/bottom/bottomnotok6.png"
import bottomnotok7 from "../img/bottom/bottomnotok7.png"
import bottomnotok8 from "../img/bottom/bottomnotok8.png"
import bottomnotok9 from "../img/bottom/bottomnotok9.png"
import bottomnotok10 from "../img/bottom/bottomnotok10.png"

const L2Images = () => {
  const [activeTab, setActiveTab] = useState('top');

  const TopImages = () => (
    <>
      {/* 4 DO Examples */}
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">Good Top Image Examples</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-4">
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
               <img src={topok1} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 1
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topok2} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 2
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topok3} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 3
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topok4} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 4
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Painting Looking - 4 DON'T */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">Painting Looking</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-4">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok1} alt="" />
              </div>
              <div className="help-center__image-caption">
                We cannot recognize the shape properly
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok2} alt="" />
              </div>
              <div className="help-center__image-caption">
              Looks like photoshop
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok3} alt="" />
              </div>
              <div className="help-center__image-caption">
              Bad inpainting
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok4} alt="" />
              </div>
              <div className="help-center__image-caption">
              Does not match the original image shade
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Weird Shape - 4 DON'T */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">Weird Shape</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-4">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok5} alt="" />
              </div>
              <div className="help-center__image-caption">
                Bad nipple shape
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok6} alt="" />
              </div>
              <div className="help-center__image-caption">
              Bad nipple shape
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok7} alt="" />
              </div>
              <div className="help-center__image-caption">
              Bad nipple shape
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
              <img src={topnotok8} alt="" />
              </div>
              <div className="help-center__image-caption">
              Bad nipple shape
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* No Nipple - 1 DON'T */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">No Nipple</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--single">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '300px', height: '300px'}}>
              <img src={topnotok9} alt="" />
              </div>
              <div className="help-center__image-caption">
                No nipple visible
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Weird Colour - 1 DON'T */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">Weird Colour</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--single">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '300px', height: '300px'}}>
              <img src={topnotok10} alt="" />
              </div>
              <div className="help-center__image-caption">
                Weird colour issue, almost invisible
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const BottomImages = () => (
    <>
      {/* 6 DO Examples */}
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">Good Bottom Image Examples</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images" style={{display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '16px'}}>
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '150px', height: '150px'}}>
                <img src={bottomok1} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 1
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '150px', height: '150px'}}>
                <img src={bottomok2} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 2
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '150px', height: '150px'}}>
                <img src={bottomok3} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 3
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '150px', height: '150px'}}>
                <img src={bottomok4} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 4
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '150px', height: '150px'}}>
                <img src={bottomok5} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 5
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box" style={{width: '150px', height: '150px'}}>
                <img src={bottomok6} alt="" />
              </div>
              <div className="help-center__image-caption">
                Good example 6
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4 DON'T Examples */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">WEIRD SHAPE</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-4">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
                <img src={bottomnotok1} alt="" />
              </div>
              <div className="help-center__image-caption">
              WEIRD SHAPE
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
                <img src={bottomnotok2} alt="" />
              </div>
              <div className="help-center__image-caption">
              WEIRD SHAPE
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
                <img src={bottomnotok3} alt="" />
              </div>
              <div className="help-center__image-caption">
              WEIRD SHAPE
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '200px', height: '200px'}}>
                <img src={bottomnotok4} alt="" />
              </div>
              <div className="help-center__image-caption">
              WEIRD SHAPE
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2 DON'T Examples - First row */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">NO PUSSY</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-2">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '250px', height: '250px'}}>
                <img src={bottomnotok5} alt="" />
              </div>
              <div className="help-center__image-caption">
              NO PUSSY
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '250px', height: '250px'}}>
                <img src={bottomnotok6} alt="" />
              </div>
              <div className="help-center__image-caption">
              NO PUSSY
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2 DON'T Examples - Second row */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">ASYMETRICAL</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-2">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '250px', height: '250px'}}>
                <img src={bottomnotok7} alt="" />
              </div>
              <div className="help-center__image-caption">
              ASYMETRICAL
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '250px', height: '250px'}}>
                <img src={bottomnotok8} alt="" />
              </div>
              <div className="help-center__image-caption">
              ASYMETRICAL
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 1 DON'T Example - First single */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">UNREALISTIC</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--single">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '300px', height: '300px'}}>
                <img src={bottomnotok9} alt="" />
              </div>
              <div className="help-center__image-caption">
              UNREALISTIC
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 1 DON'T Example - Second single */}
      <div className="help-center__examples">
        <div className="help-center__examples-header">
          <h3 className="help-center__examples-title">TOO SMALL</h3>
        </div>
        
        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--single">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '300px', height: '300px'}}>
                <img src={bottomnotok10} alt="" />
              </div>
              <div className="help-center__image-caption">
              TOO SMALL
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const tabs = {
    top: {
      title: 'Top',
      icon: <ArrowUpward />,
      component: <TopImages />
    },
    bottom: {
      title: 'Bottom',
      icon: <ArrowDownward />,
      component: <BottomImages />
    }
  };

  return (
    <div className="l1-help">
      {/* Tabs Header */}
      <div className="l1-help__tabs">
        {Object.entries(tabs).map(([id, tab]) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`l1-help__tab ${activeTab === id ? 'l1-help__tab--active' : ''}`}
          >
            <div className="l1-help__tab-icon">{tab.icon}</div>
            <span className="l1-help__tab-title">{tab.title}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="l1-help__content">
        {tabs[activeTab]?.component}
      </div>
    </div>
  );
};

export default L2Images;